export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}
